import React, { useState, useEffect, useCallback } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Home from "./pages/Home";
import Work from "./pages/Work";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import AnimatedCursor from "./components/AnimatedCursor";
import FixedSocials from "./components/FixedSocials";
import ScrollToTop from "./components/ScrollToTop";

import "./App.css";
import TravelBuddy from "./pages/projects/TravelBuddy";
import ProjectOverview from "./pages/projects/ProjectOverview";
import NotificationContext from "./context/NotificationContext";
import SnackBar from "./components/SnackBar";

// The custom cursor only makes sense with a precise pointer (mouse/trackpad).
const FINE_POINTER_QUERY = "(hover: hover) and (pointer: fine) and (min-width: 769px)";

function App() {
	const [showCursor, setShowCursor] = useState(
		() => window.matchMedia(FINE_POINTER_QUERY).matches
	);
	const [message, setMessage] = useState("");

	const showSnackbar = useCallback((message) => {
		setMessage(message);
	}, []);

	useEffect(() => {
		const query = window.matchMedia(FINE_POINTER_QUERY);
		const handleChange = () => setShowCursor(query.matches);
		query.addEventListener("change", handleChange);
		return () => query.removeEventListener("change", handleChange);
	}, []);

	return (
		<MotionConfig reducedMotion="user">
			<NotificationContext.Provider value={showSnackbar}>
				<Header />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/work" element={<Work />} />
					<Route path="/about" element={<About />} />

					{/* project pages */}
					<Route path="/works/travelbuddy" element={<TravelBuddy />} />
					<Route
						path="/works/smartmoney"
						element={<ProjectOverview slug="smartmoney" />}
					/>
					<Route
						path="/works/windshield-2020"
						element={<ProjectOverview slug="windshield-2020" />}
					/>
					<Route path="/works" element={<Navigate to="/work" replace />} />

					<Route path="*" element={<NotFound />} />
				</Routes>
				<ScrollToTop />
				<Footer />
				<FixedSocials />
				{showCursor && <AnimatedCursor />}
				<SnackBar message={message} onDismiss={() => setMessage("")} />
			</NotificationContext.Provider>
		</MotionConfig>
	);
}

export default App;
